<template>
  <span ref="dataNumber"></span>
</template>
<script>
import anime from 'animejs/lib/anime.es.js'
export default {
  data () {
    return {}
  },
  props: {
    dataValue: {
      type: Number,
      default: 0
    },
    round: {
      type: Number,
      default: 100
    }
  },
  mounted () {
    this.showData()
  },
  methods: {
    showData () {
      let el = this.$refs.dataNumber
      var myObject = {data1: 0}
      anime({
        targets: myObject,
        data1: this.dataValue,
        easing: 'linear',
        round: this.round,
        duration: 800,
        update: () => {
          el.innerHTML = JSON.stringify(myObject.data1)
        }
      })
    }
  },
  watch: {
    dataValue () {
      this.showData()
    }
  }
}
</script>
<style scoped lang='stylus'>
</style>